import { buildCategoryGroups } from '@/components/cashflow/helpers';
import { useTransactionEntryCategories } from '@common/react/cashflow';
import { sortBy } from '@common/util/arrays';
import { useMemo } from 'react';

const useCategoryOptions = () => {
    const { transactionEntryCategories } = useTransactionEntryCategories();

    return useMemo(
        () =>
            sortBy(
                Object.values(
                    buildCategoryGroups(transactionEntryCategories)
                        .categoryGroups
                ),
                'label',
                'ASC'
            ),
        [transactionEntryCategories]
    );
};

export default useCategoryOptions;
